<template>
  <div class="user">
    <!--内容-->
    <div class="product-content">
    <div class="common-form mt30">图片点击统计</div>
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="user" label="广告图" width="200">
            <template slot-scope="scope">
                <el-image 
                    style="width: 200px; height: 100px"
                    :src="scope.row.image_url" 
                    :preview-src-list="[scope.row.image_url]">
                </el-image>
            </template>
          </el-table-column>
          <el-table-column prop="view_times" label="点击次数"></el-table-column>
          <el-table-column fixed="right" label="操作" width="160">
            <template slot-scope="scope">
              <el-button @click="addClick(scope.row)" type="text" size="small">操作</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
    <Add v-if="open_add" :open_add="open_add" :model="model" @closeDialog="closeDialogFunc($event, 'add')"></Add>
  </div>
</template>

<script>
  import StatisticsApi from '@/api/statistics.js';
  import Add from './dialog/Add.vue';
  export default {
    components: {
      /*编辑组件*/
      Add,
    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        model: [],
        /*是否打开添加弹窗*/
        open_add: false,
        /*横向表单数据模型*/
        formInline: {
          user_id: '',
          nickName: '',
        },
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();

    },
    methods: {

      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        // console.log(Params);
        StatisticsApi.getViewsList(Params, true)
        .then(res => {
         self.tableData = res.data.list.data;
         self.totalDataNumber = res.data.list.total;
         self.loading = false;
        })
        .catch(error => {
        });
      },


      /*打开添加*/
      addClick(item) {
        this.model = item
        this.open_add = true;
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        if (f == 'add') {
          this.open_add = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
      },

    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/statistics/banner/part/List.vue